import { useSearchParams } from "react-router";

// Куда вернуть пользователя после входа: исходный URL защищённого маршрута в query `returnTo`.
const RETURN_TO = "returnTo";

/** `pathname` с параметром `returnTo`; без него — сам `pathname`. */
export function withReturnTo(pathname: string, returnTo: string | null): string {
  return returnTo ? `${pathname}?${new URLSearchParams({ [RETURN_TO]: returnTo })}` : pathname;
}

/** `returnTo` текущего URL, если он ведёт внутрь приложения. */
export function useReturnTo(): string | null {
  const [searchParams] = useSearchParams();
  const value = searchParams.get(RETURN_TO);
  // Только пути этого же приложения: `//host` и абсолютные URL открыли бы чужой сайт.
  return value?.startsWith("/") && !value.startsWith("//") ? value : null;
}
